import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import useDateRangePicker from '../../../../../components/organisms/forms/date-range-picker/reusable-func';
import api from '../../../../../components/api';
import { CoffeeInvoice } from '../hooks';
import clientByIdDummy from '../clientById.json';

function useClientCoffeeInvoice() {
  /*
   *
   *
   *
   *
   *
   *
   *
   */

  /*
  * Get Initial Data
  * 1. param from url format : clients/invoice/:clientId
  * 2. Get clientName from clientId, clientName is needed for fetching invoices data
  */

  // 1. Get Params from url
  const { clientId } = useParams();

  // 2.3. Get invoice list by clientName
  const { data: invoicesRes, isLoading: invoicesLoading } = useQuery(
    ['coffee-invoices-by-client', 'client', clientId],
    () => api.clients.getClientCoffeeInvoices(clientId!),
    {
      enabled: !!clientId,
    },
  );

  // 2.4. Filter Invoices list by search value
  const [searchValue, setSearchValue] = React.useState<string>('');
  const onChangeSearchValue = (text: string) => setSearchValue(text);

  // 2.5 Filter by DateRangePicker
  const { handleChangeStartDate, handleChangeEndDate, selectedDate } = useDateRangePicker();

  // 2.5 Result Invoices after filter and fetching
  const paidInvoiceList: CoffeeInvoice[] | [] = React.useMemo(() => {
    const resData: CoffeeInvoice[] | undefined = invoicesRes?.data?.data;
    if (resData) {
      console.log(resData.length);
      return resData.filter((paid) => {
        console.log(JSON.stringify(paid));
        const { paidDate } = paid;
        const filterBySearch: boolean = JSON.stringify(paid).toLowerCase().includes(searchValue.toLowerCase());
        const filterByStartDate: boolean = new Date(new Date(paid.paidDate).setDate(new Date(paid.paidDate).getDate() - 1)).getTime() >= new Date(selectedDate.start).getTime();
        const filterByEndDate: boolean = new Date(new Date(paid.paidDate).setDate(new Date(paid.paidDate).getDate() - 1)).getTime() <= new Date(selectedDate.end).getTime();
        return paidDate && filterBySearch && filterByStartDate && filterByEndDate;
      });
    }
    return [];
  }, [invoicesRes, searchValue, selectedDate]);

  return {
    handleChangeStartDate,
    handleChangeEndDate,
    onChangeSearchValue,
    searchValue,
    selectedDate,
    paidInvoiceList,
    invoicesLoading,
  };
}

export default useClientCoffeeInvoice;
